import React, { useState, useEffect } from 'react'
import {
   Typography,
   Grid,
   IconButton,
   Button,
   Card,
   CardMedia,
   CardContent,
   Modal,
   Paper,
   Chip,
   Snackbar
} from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import Dropzone from 'react-dropzone'
import moment from 'moment'
import 'moment/locale/es'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import DeleteIcon from '@material-ui/icons/Delete'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import thumbnail from 'images/components/dropzonevideo/thumbnail.jpg'
import useVideoDropZoneStyles from './styles'
import { postToApi, getFromApi, deleteToApi } from 'actions'
import WarningOutlinedIcon from '@material-ui/icons/WarningOutlined'
import Tooltip from '@material-ui/core/Tooltip'
import ReactPlayer from 'react-player'
import { useStateValue } from 'context/store'

function DropZoneVideo({ selected, closeDropZone }) {
   const VIDEO_SIZE = 50000000 // Tamaño de los videos en bytes
   const ACCEPTED_FORMATS = 'video/*, application/mp4, application/mkv'
   const [{ sessionUser }, dispatch] = useStateValue()
   const classes = useVideoDropZoneStyles()
   const [fileList, setFileList] = useState([])
   const [temporalFile, setTemporalFile] = useState(null)
   const [confirmationMessage, setConfirmationMessage] = useState(false)
   const [openModal, setOpenModal] = useState(false)
   const [showError, setShowError] = useState(false)
   const [showSuccess, setShowSuccess] = useState(false)
   const [textError, setTextError] = useState('')
   const [filesVideos, setFilesVideos] = useState(true)
   const [showSuccessDelete, setShowSuccessDelete] = useState(false)

   const handleFileAdd = (acceptedFiles, fileRejections) => {
      console.log('🚀 ~ file: index.js:47 ~ handleFileAdd ~ fileRejections', fileRejections)
      if (fileRejections.length === 0) {
         setTemporalFile(acceptedFiles)
         setConfirmationMessage(true)
      } else {
         setShowError(true)
         const textoError = 'La extensión de video no es válida'
         setTextError(textoError)
         // setShowError(true)
         // if (fileRejections[0].errors[0].code == 'file-too-large') {
         //     let textoError = 'El archivo de video sobrepasa el peso permitido'
         //     setTextError(textoError)
         // } else {
         //     let textoError = 'La extensión de video no es válida'
         //     setTextError(textoError)
         // }
      }
   }
   const successBanner = () => {
      setShowSuccess(true)
   }

   const arrayListVideos = async () => {
      const { code } = selected

      const url = `${process.env.REACT_APP_FUNCTIONALITIES_API}/functionalities/upload-video?functionalityCode=${code}`

      const data = await getFromApi(url)
      const { videos } = data
      // console.log('data', data)
      // setFileList(selected?.videos)
      setFileList(videos)
      setFilesVideos(false)
   }
   const statusUploadVideos = async codeVideo => {
      const tokenApp = localStorage.getItem('token_app')
      const URL_STATUS_UPLOAD = `${process.env.REACT_APP_AUTHORIZATION_API}/user/chenge/status`
      const dataSend = {
         table: 'FUNCTIONALITY_VIDEO',
         code: codeVideo
      }
      const requestOptions = {
         method: 'PUT',
         headers: {
            Authorization: `Bearer ${tokenApp}`,
            'Content-type': 'application/json'
         },
         body: JSON.stringify(dataSend)
      }
      fetch(URL_STATUS_UPLOAD, requestOptions)
         .then(res => {
            console.log('🚀 ~ file: index.js:120 ~ statusUploadVideos ~ res', res)
            dispatch({ type: 'CLOSE_SPINNER' })
            if (res?.status === 200) {
               dispatch({
                  type: 'OPEN_SNACKBAR',
                  openMessage: {
                     open: true,
                     message: ` Video cargado exitosamente`,
                     severity: 'info'
                  }
               })
            }
         })
         .catch(err => {
            dispatch({ type: 'CLOSE_SPINNER' })
            dispatch({
               type: 'OPEN_SNACKBAR',
               openMessage: {
                  open: true,
                  message: ` Ocurrio un error al intentar subir archivos`,
                  severity: 'error'
               }
            })
         })
   }

   // Segundo llamado para enviar el video
   const uploadVideo = async (url, metadata, codeVideo) => {
      const requestOptions = {
         method: 'PUT',
         headers: {
            'Content-Type': temporalFile[0]?.type,
            ...metadata
         },
         body: temporalFile[0]
      }
      fetch(url, requestOptions)
         .then(res => {
            if (res?.status === 200) {
               statusUploadVideos(codeVideo)
            }
         })
         .catch(err => {
            dispatch({ type: 'CLOSE_SPINNER' })
            dispatch({
               type: 'OPEN_SNACKBAR',
               openMessage: {
                  open: true,
                  message: ` Ocurrio un error al intentar subir archivos`,
                  severity: 'error'
               }
            })
         })
   }

   // Primer llamado para crear la URL prefirmada:
   const videoFileUrlPresigned = async () => {
      const tokenApp = localStorage.getItem('token_app')
      try {
         dispatch({ type: 'OPEN_SPINNER' })
         const { code: functionalityCode } = selected
         const URL_PRESIGNED_VIDEO = `${process.env.REACT_APP_FUNCTIONALITIES_API}/functionalities/generated/url/video`
         const dataSend = {
            folder: 'pruebas/v21/',
            fileName: temporalFile[0]?.name,
            duration: 120,
            metadata: {},
            functionalityCode
         }
         const requestOptions = {
            method: 'POST',
            headers: {
               Authorization: `Bearer ${tokenApp}`,
               'Content-type': 'application/json'
            },
            body: JSON.stringify(dataSend)
         }
         fetch(URL_PRESIGNED_VIDEO, requestOptions)
            .then(response => response.json())
            .then(data => {
               uploadVideo(data?.link, data?.metadata, data?.code)
            })
      } catch {
         dispatch({ type: 'CLOSE_SPINNER' })
         dispatch({
            type: 'OPEN_SNACKBAR',
            openMessage: {
               open: true,
               message: ` Ocurrio un error al intentar subir archivos`,
               severity: 'error'
            }
         })
      }
   }

   const uploadFile = async file => {
      try {
         dispatch({ type: 'OPEN_SPINNER' })
         // successBanner()
         const { module, code } = selected
         const payload = new FormData()
         payload.append('functionalityCode', code)
         payload.append('file', temporalFile[0])

         const url = `${process.env.REACT_APP_FUNCTIONALITIES_API}/functionalities/upload-video`

         const { errors, message } = await postToApi(url, payload)
         if (!errors) {
            dispatch({ type: 'CLOSE_SPINNER' })
            dispatch({
               type: 'OPEN_SNACKBAR',
               openMessage: {
                  open: true,
                  message: ` Video cargado exitosamente`,
                  severity: 'info'
               }
            })
         }
      } catch (error) {
         console.log(error)
         dispatch({ type: 'CLOSE_SPINNER' })
         dispatch({
            type: 'OPEN_SNACKBAR',
            openMessage: {
               open: true,
               message: ` Ocurrio un error al intentar subir archivos`,
               severity: 'error'
            }
         })
      }
      updateFileList()
   }

   const updateFileList = () => {
      setFileList([...fileList, temporalFile[0]])
      setOpenModal(false)
      setTemporalFile(null)
      // setConfirmationMessage(false)
      arrayListVideos()
   }

   const cancelFileUpload = () => {
      setTemporalFile(null)
      setConfirmationMessage(false)
   }

   const addVideo = () => {
      cancelFileUpload()
      setOpenModal(true)
   }

   const kiloBytesToMegabytes = bytes => {
      const megabytes = Math.round(bytes * 0.00001) / 10
      return `${megabytes} mb`
   }

   const timeStampToDate = timestamp => {
      const arrayDate = timestamp.split('-')
      const day = parseInt(arrayDate[0]) + parseInt(1)
      const videoDate = moment(new Date(`${arrayDate[2]}-${arrayDate[1]}-${day}`))

      return videoDate.format('DD MMM YYYY')
   }

   const closeError = () => {
      setShowError(false)
   }
   const closeSucces = () => {
      setShowSuccess(false)
      setShowSuccessDelete(false)
   }

   const removeVideo = async videoToDelete => {
      try {
         const videoList = fileList
         const filteredVideos = videoList.filter(video => video.name !== videoToDelete.name)
         setFileList(filteredVideos)

         const url = `${process.env.REACT_APP_FUNCTIONALITIES_API}/functionalities/video/delete?functionalityVideoCode=${videoToDelete.code}`

         await deleteToApi(url)
         setShowSuccessDelete(true)
      } catch (error) {
         console.log(error)
      }
   }

   const AddVideoModal = () => {
      return (
         <Modal open={openModal} disableEscapeKeyDown={false}>
            <div className={classes.modalContainer}>
               <Paper elevation={6} className={classes.modalContent}>
                  <DropZoneVideoModal />
               </Paper>
            </div>
         </Modal>
      )
   }

   const ConfirmationMessage = () => {
      return (
         <div className={classes.modal}>
            <div className={classes.paper}>
               <Grid className={classes.confirmModalContainer}>
                  <div className={classes.iconContainer}>
                     <WarningOutlinedIcon className={classes?.warningIcon} />
                  </div>
                  <Typography variant="subtitle1">
                     ¿Está seguro que desea subir el video {temporalFile[0].name} ?
                  </Typography>
                  <Grid
                     item
                     container
                     spacing={10}
                     style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 10
                     }}
                  >
                     <Button variant="outlined" color="primary" style={{ marginRight: 30 }} onClick={cancelFileUpload}>
                        Cancelar
                     </Button>
                     <Button
                        variant="contained"
                        color="primary"
                        // onClick={() => uploadFile(temporalFile[0].name)}
                        onClick={() => videoFileUrlPresigned()}
                     >
                        Aceptar
                     </Button>
                  </Grid>
               </Grid>
            </div>
         </div>
      )
   }

   const UploadVideoMessage = () => {
      return (
         <Grid container direction="column">
            <Typography variant="subtitle1">
               Arrastre y suelte su archivo de video aquí, o haga click para seleccionarlo desde su equipo
            </Typography>
         </Grid>
      )
   }

   const urlVideoSigned = async videoCode => {
      try {
         const url = `${process.env.REACT_APP_FUNCTIONALITIES_API}/functionalities/generate-url-video?functionalityCode=${videoCode}`
         const videoSigned = await postToApi(url, '')
         if (videoSigned) {
            return videoSigned.url
         }
      } catch (error) {
         console.error(error)
      }
   }

   const DropZoneVideoModal = () => {
      return (
         <div className={classes.dropZoneAreaModal} key={`drop-zone-${selected?.id}`}>
            <div className={classes.topBoxModal} onClick={() => setOpenModal(false)}>
               <Tooltip title="Cerrar">
                  <IconButton aria-label="Cerrar">
                     <HighlightOffIcon className={classes.closeIcon} />
                  </IconButton>
               </Tooltip>
            </div>
            <Dropzone
               onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
               maxFiles={1}
               accept={ACCEPTED_FORMATS}
               // maxSize={VIDEO_SIZE}
            >
               {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}>
                     <input {...getInputProps()} />

                     <IconButton aria-label="upload-video" className={classes.uploadIconModal}>
                        <CloudUploadIcon style={{ fontSize: 60 }} />
                     </IconButton>
                  </div>
               )}
            </Dropzone>
            {confirmationMessage ? <ConfirmationMessage /> : <UploadVideoMessage />}
         </div>
      )
   }

   const DropZoneVideo = () => {
      if (filesVideos) {
         arrayListVideos()
      }

      return (
         <div className={classes.dropZoneArea} key={`drop-zone-${selected?.id}`}>
            <div className={classes.topBox} onClick={() => closeDropZone()}>
               <Tooltip title="Cerrar">
                  <IconButton aria-label="Cerrar">
                     <HighlightOffIcon className={classes.closeIcon} />
                  </IconButton>
               </Tooltip>
            </div>
            <Dropzone
               onDrop={(acceptedFiles, fileRejections) => handleFileAdd(acceptedFiles, fileRejections)}
               maxFiles={1}
               accept={ACCEPTED_FORMATS}
               // maxSize={VIDEO_SIZE}
            >
               {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}>
                     <input {...getInputProps()} />

                     <IconButton aria-label="upload-video" className={classes.uploadIcon}>
                        <CloudUploadIcon style={{ fontSize: 35 }} />
                     </IconButton>
                  </div>
               )}
            </Dropzone>
            {confirmationMessage ? <ConfirmationMessage /> : <UploadVideoMessage />}
         </div>
      )
   }

   return (
      <>
         <AddVideoModal />
         <Snackbar
            open={showError}
            autoHideDuration={6000}
            onClose={closeError}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
         >
            <Alert onClose={closeError} severity="error">
               {textError}
            </Alert>
         </Snackbar>
         <Snackbar
            open={showSuccess}
            autoHideDuration={7000}
            onClose={closeSucces}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
         >
            <Alert onClose={closeSucces} severity="info">
               Video cargado exitosamente
            </Alert>
         </Snackbar>
         <Snackbar
            open={showSuccessDelete}
            autoHideDuration={7000}
            onClose={closeSucces}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
         >
            <Alert onClose={closeSucces} severity="info">
               Video eliminado exitosamente
            </Alert>
         </Snackbar>
         {fileList.length > 0 ? (
            <VideoList
               classes={classes}
               fileList={fileList}
               addVideo={addVideo}
               urlVideoSigned={urlVideoSigned}
               removeVideo={removeVideo}
            />
         ) : (
            <DropZoneVideo />
         )}
      </>
   )
}

const VideoItem = ({ video, classes, urlVideoSigned, removeVideo }) => {
   // const videoDate = timeStampToDate(video.createdDate)
   const [videoUrl, setVideoUrl] = useState(null)
   const [statusApi, setStatusApi] = useState(true)

   useEffect(() => {
      if (statusApi) {
         urlVideoSigned(video.code).then(data => setVideoUrl(data))
      }

      return () => {
         setStatusApi(false)
      }
   }, [])
   return (
      <Card className={classes.cardVideo}>
         <div className={classes.containerVideoItem}>
            <ReactPlayer url={videoUrl} width="240px" height="170px" controls />
         </div>
         <CardContent style={{ justifyContent: 'flex-start', textAlign: 'left' }}>
            <Grid container justifyContent="space-between" direction="row" alignItems="center">
               <Grid item xs={10}>
                  <Typography gutterBottom style={{ fontSize: 15, fontWeight: 'bold' }}>
                     {video.originalName}
                  </Typography>
               </Grid>
               <Grid item xs={2}>
                  <IconButton
                     aria-label="delete-video"
                     className={classes.deleteIconButton}
                     onClick={() => removeVideo(video)}
                  >
                     <DeleteIcon className={classes.deleteIcon} />
                  </IconButton>
               </Grid>
            </Grid>
            <Typography variant="caption" color="textSecondary">
               {video.createdDate}
            </Typography>
         </CardContent>
      </Card>
   )
}

const VideoList = ({ classes, fileList, addVideo, urlVideoSigned, removeVideo }) => {
   return (
      <div className={classes.videoList}>
         <Grid container direction="row">
            {fileList.map((file, index) => (
               <Grid item xs={2} key={index}>
                  <VideoItem classes={classes} video={file} urlVideoSigned={urlVideoSigned} removeVideo={removeVideo} />
               </Grid>
            ))}
            <Grid item xs={2} key="add-video-button" className={classes.addVideoContainer}>
               <IconButton onClick={addVideo} className={classes.addVideoButton}>
                  <AddCircleOutlineIcon className={classes.addVideoIcon} />
               </IconButton>
               <Typography> Agregar otro video </Typography>
            </Grid>
         </Grid>
      </div>
   )
}

export default DropZoneVideo
